import {FileInput as FileInputComponent, File, Container } from './FileInput'

export const FileInput = Object.assign(
  FileInputComponent, { File, Container }
)
